import ButtonGroup from "@visa/vds/button-group";
import ButtonText from "@visa/vds/button-text";
import Col from "@visa/vds/col";
import Grid from "@visa/vds/grid";
import Row from "@visa/vds/row";
import Td from "@visa/vds/td";
import Tr from "@visa/vds/tr";
import Typography from "@visa/vds/typography";
import React, { useEffect, useState } from "react";
import MCSLoading from "../../../components/MCSLoading";
import MCSPagedTable from "../../../components/MCSPagedTable";
import { LibraryAdminApi } from "../../../services/library.admin.service";
import ActionMenu from "./Components/ActionMenu";
import MCSConfirmDialog from "../../../components/MCSConfirmDialog";
import { GlobalAlertContext } from "../../../context/GlobalAlertContext";
import TagDialog from "./Components/TagDialog";
import { trackPromise, usePromiseTracker } from "react-promise-tracker";

function ManageTag() {
  const [error, setError] = useState(null);
  const [tagList, setTagList] = useState(null);
  const [tag, setTag] = useState({ id: 0, name: "" });
  const [dialog, setDialog] = useState({ open: false });
  const [confirmDialog, setConfirmDialog] = useState(null);
  const { promiseInProgress } = usePromiseTracker();

  let colHeaders = [
    { displayName: "Tag Name", name: "name", orderable: false },
    { displayName: "", name: "action", orderable: false },
  ];

  const handleClickEdit = (e) => {
    let id = Number(e.currentTarget.dataset.id);
    const tag = tagList.filter((i) => {
      return i.id === id;
    });
    if (tag && tag.length > 0) {
      setTag(tag[0]);
      setDialog({ open: true });
    }
  };

  const deleteConfirmHandler = (id, alertObj) => {
    trackPromise(
      LibraryAdminApi.deleteTag(id)
        .then((res) => {
          alertObj.setSuccessMessage("Delete success!");
          fetchData();
        })
        .catch((error) =>
          alertObj.setErrorMessage("Unexpected error please try again.")
        )
    );
  };

  const handleClickDelete = (e) => {
    let id = e.currentTarget.dataset.id;
    let name = e.currentTarget.dataset.name;
    setConfirmDialog({
      ...confirmDialog,
      title: "Delete Tag",
      type: "warning",
      message: "Are you sure you want to delete <b>" + name + "</b> ?",
      open: true,
      data: id,
    });
  };

  const handleClickSave = (alertObj, updateDto) => {
    setDialog({ open: false });
    trackPromise(
      LibraryAdminApi.saveTag(updateDto)
        .then((res) => {
          alertObj.setSuccessMessage("Save success!");
          fetchData();
        })
        .catch((error) => {
          alertObj.setErrorMessage(error);
        })
    );
  };

  const handleClickAdd = () => {
    setDialog({ ...dialog, open: true });
    setTag({ id: 0, name: "" });
  };

  const fetchData = async () =>
    trackPromise(
      LibraryAdminApi.getTagList()
        .then((result) => {
          setTagList(result.data.tagList);
        })
        .catch((error) => setError(error))
    );

  useEffect(() => {
    fetchData();
  }, []);

  if (error) {
    return <div>Error: {error.message}</div>;
  } else {
    return (
      <GlobalAlertContext.Consumer>
        {(alertObj) => (
          <>
            {confirmDialog && (
              <MCSConfirmDialog
                alertObj={alertObj}
                confirmHandler={deleteConfirmHandler}
                confirmDialog={confirmDialog}
                setConfirmDialog={setConfirmDialog}
              />
            )}
            <TagDialog
              alertObj={alertObj}
              dialog={dialog}
              setDialog={setDialog}
              tag={tag}
              setTag={setTag}
              tagList={tagList}
              handleClickSave={handleClickSave}
            />
            <Grid>
              <Row>
                <Col>
                  <Typography tag="h1">Manage Tags</Typography>
                </Col>
              </Row>
              {promiseInProgress && <MCSLoading />}
              {!promiseInProgress && tagList && (
                <>
                  <Row>
                    <Col xs={3} sm={3} md={6} lg={8} xl={8}></Col>
                    <Col>
                      <ButtonGroup direction="right">
                        <ButtonText onClick={handleClickAdd}>
                          Add New Tag
                        </ButtonText>
                      </ButtonGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <MCSPagedTable
                        size={"compact"}
                        colHeaders={colHeaders}
                        useSearchBar={false}
                        usePagination={false}
                        tableData={
                          tagList &&
                          tagList.map((row, key) => (
                            <Tr key={key}>
                              <Td>{row.name}</Td>
                              <Td style={{ textAlign: "right" }}>
                                <ActionMenu
                                  dataId={row.id}
                                  dataName={row.name}
                                  handleClickEdit={handleClickEdit}
                                  handleClickDelete={handleClickDelete}
                                />
                              </Td>
                            </Tr>
                          ))
                        }
                      />
                    </Col>
                  </Row>
                </>
              )}
            </Grid>
          </>
        )}
      </GlobalAlertContext.Consumer>
    );
  }
}
export default ManageTag;
